document.addEventListener('DOMContentLoaded', function () {

  // ── Utilitaire : injecter le message précommande ──────────
  function injectPreorderMessage() {
    const msgHTML = `
      <div class="preorder-popup-message">
        <strong>Précommande</strong><br>
        Cet article n'est pas en stock.<br>
        Il sera expédié dès sa disponibilité.<br>
        <a href="/policies/shipping-policy">En savoir plus</a>
      </div>
    `;

    // Desktop
    const rightCol = document.querySelector('#modalAddToCartProduct [data-preorder]');
    if (rightCol && !rightCol.querySelector('.preorder-popup-message')) {
      rightCol.insertAdjacentHTML('afterbegin', msgHTML);
    }

    // Mobile
    const mobileBlock = document.querySelector('#modalAddToCartProduct .tt-modal-addtocart.mobile');
    if (mobileBlock && !mobileBlock.querySelector('.preorder-popup-message')) {
      const messages = mobileBlock.querySelector('.tt-modal-messages');
      const target = messages || mobileBlock;
      target.insertAdjacentHTML(messages ? 'afterend' : 'afterbegin', msgHTML);
    }
  }

  // ── Nettoyage à chaque ouverture ─────────────────────────
  $('#modalAddToCartProduct').on('show.bs.modal', function () {
    document.querySelectorAll('#modalAddToCartProduct .preorder-popup-message').forEach(el => el.remove());
  });

  // ── À l'ouverture de la modal ─────────────────────────────
  $('#modalAddToCartProduct').on('shown.bs.modal', async function () {

    const rightCol = document.querySelector('#modalAddToCartProduct [data-preorder]');

    // ── Page produit : Liquid a déjà positionné data-preorder ──
    if (rightCol?.dataset.preorder === 'true') {
      injectPreorderMessage();
      return;
    }

    // ── Listing : lire le dernier item ajouté via /cart.js ────
    try {
      // Récupérer le titre affiché dans la modal pour identifier le bon item
      const modalTitle = document.querySelector('#modalAddToCartProduct .tt-title-js')?.textContent.trim();

      const cartRes = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await cartRes.json();

      if (!cart.items?.length) return;

      // Trouver l'item correspondant au produit affiché dans la modal
      let targetItem = null;
      if (modalTitle) {
        targetItem = cart.items.find(i =>
          i.title?.includes(modalTitle) || modalTitle.includes(i.product_title)
        );
      }
      // Fallback : prendre le premier item (le plus récemment ajouté)
      if (!targetItem) targetItem = cart.items[0];

      if (!targetItem?.handle) return;

      // Lire les tags du produit
      const prodRes = await fetch(`/products/${targetItem.handle}.js`, { cache: 'no-store' });
      const product = await prodRes.json();

      console.log('[Preorder] Tags du produit:', product.tags);

      if (product.tags?.includes('PRECOMMANDES')) {
        // Mettre à jour data-preorder pour cohérence
        if (rightCol) rightCol.dataset.preorder = 'true';
        injectPreorderMessage();
      }

    } catch (err) {
      console.warn('[Preorder] Erreur:', err);
    }
  });

});